const mainCollection = () => {
    const customFilterButtons = () => {
        const customFilterButtonContainer = document.querySelector('.facets__floating-filter--custom');
        if (customFilterButtonContainer) {
            const getSortOptions = () => {
                const applyFilterButton = document.querySelector('facet-drawer [is="facet-apply-button"]');
                const sortFilterOptions = document.querySelectorAll('facet-drawer #accordion-sort-by input[type="radio"]');
                sortFilterOptions.forEach((option) => {
                    option.addEventListener('change', () => {
                        applyFilterButton === null || applyFilterButton === void 0 ? void 0 : applyFilterButton.click();
                    });
                });
            };
            const filterButton = customFilterButtonContainer.querySelector('.button.button--xl:nth-child(1)');
            filterButton.addEventListener('click', () => {
                const facetDrawer = document.querySelector('facet-drawer');
                facetDrawer.setAttribute('open-from', 'left');
                facetDrawer.classList.remove('facets-drawer--sort');
                facetDrawer.classList.add('facets-drawer--filter');
                facetDrawer.classList.add('drawer--full-page');
                const header = facetDrawer.querySelector('[slot="header"]');
                header.innerHTML = 'Filter';
            });
            const sortButton = customFilterButtonContainer.querySelector('.button.button--xl:nth-child(2)');
            sortButton.addEventListener('click', () => {
                const facetDrawer = document.querySelector('facet-drawer');
                facetDrawer.setAttribute('open-from', 'bottom');
                facetDrawer.classList.remove('drawer--full-page');
                facetDrawer.classList.remove('facets-drawer--filter');
                facetDrawer.classList.add('facets-drawer--sort');
                const sortAccordion = facetDrawer.querySelector('[id="accordion-sort-by"]');
                sortAccordion.setAttribute('open', '');
                sortAccordion.setAttribute('aria-expanded', 'true');
                const header = facetDrawer.querySelector('[slot="header"]');
                header.innerHTML = 'Sort';
                getSortOptions();
            });
        }
    };
    customFilterButtons();
    const collectionLayoutToggles = () => {
        const mainCollectionSection = document.querySelectorAll('.shopify-section--main-collection');
        if (mainCollectionSection) {
            mainCollectionSection.forEach((section) => {
                const layoutToggles = section.querySelectorAll('[data-collection-layout-toggle]');
                if (layoutToggles) {
                    layoutToggles.forEach((toggle) => {
                        toggle.addEventListener('click', () => {
                            const layout = toggle.getAttribute('data-collection-layout-toggle');
                            if (layout != 'multi') {
                                section.classList.add('toggle-single-column');
                            }
                            else {
                                section.classList.remove('toggle-single-column');
                            }
                        });
                    });
                }
            });
        }
    };
    collectionLayoutToggles();
    window.addEventListener('th:facet:update:complete', () => {
        customFilterButtons();
        collectionLayoutToggles();
    });
};
export { mainCollection };
